module.exports = __webpack_public_path__ + "img/el-kerawang.4df60f12.png";